import '../Utility/Extensions/StringExtensions.js';

function hiHeader() {
    var header = document.querySelector('header');

    if (!header) return;

    Hamburger();
    Searchbox();
    NavItem();
    ActiveStates();

    document.addEventListener('keydown', function (e) {
        if (e.keyCode == 9) {
            let elem = document.querySelector(".hisc-button-search");
            if (elem) {
                elem.addEventListener('blur', function () {
                    document.querySelector("#headerSearch").focus();
                });
            }
        }
    });

    document.addEventListener('click', function (clickEv) {
        // collapse side nav bar if user clicks outside of it and it's opened

        let sideNavBarId = "navbarSupportedContent";
        let isOutsideSideNav = !(clickEv.target.id === sideNavBarId || clickEv.target.closest("#" + sideNavBarId));
        if (isOutsideSideNav) {
            let sideNavBarElem = document.getElementById(sideNavBarId);
            if (sideNavBarElem && sideNavBarElem.classList.contains('show')) { // Assumes you are using Bootstrap 4. Replace 'show' with 'in' for Bootstrap 3.
                // leverage the click event on the hamburger menu
                const hamburgerToggler = document.querySelectorAll('.navbar-toggler');
                if (hamburgerToggler.length > 0) {
                    hamburgerToggler[0].click();
                }
            }
        }

        let search = "js-search";
        let isOutsideSearch = !(clickEv.target.classList.contains(search) || clickEv.target.closest("." + search));
        if (isOutsideSearch) {
            document.body.classList.remove('search-open');
            var searchElem = document.querySelector('header .js-search');
            if (searchElem) {
                searchElem.classList.remove('open');
            }
        }
    });

    // scroll transformations
    window.onload = ScrollTransform;
    var timeout;
    window.addEventListener('scroll', function () {
        if (timeout) {
            window.cancelAnimationFrame(timeout);
        }
        timeout = window.requestAnimationFrame(ScrollTransform);
    }, false);

    function Hamburger() {
        const targets = header.querySelectorAll('.navbar-toggler');

        const tabCallback = function (e) {
            if (e.keyCode == 9) {
                let menuLinks = document.querySelectorAll(".navbar-inner > nav > ul > li > a");
                if (e.shiftKey) {
                    if (document.querySelector(".navbar-inner .navbar-toggler") == document.activeElement) {
                        menuLinks[menuLinks.length - 1].focus();
                        e.preventDefault();
                    }
                } else {
                    if (menuLinks[menuLinks.length - 1] == document.activeElement) {
                        document.querySelector(".navbar-inner .navbar-toggler").focus();
                        e.preventDefault();
                    }
                }
            }
        }

        const expansionCallback = function (mutation) {
            if (mutation.type === 'attributes') {
                var expanded = mutation.target.getAttributeNode("aria-expanded").value;

                if (expanded === 'true') {
                    document.addEventListener('keydown', tabCallback);

                    if (!document.body.classList.contains("menu-open"))
                        document.body.classList.add("menu-open");

                    document.querySelector(mutation.target.dataset.target + " ul a").focus();
                } else {
                    document.removeEventListener('keydown', tabCallback);

                    if (document.body.classList.contains("menu-open"))
                        document.body.classList.remove("menu-open");

                    let hamburger = document.querySelector(".js-hamburger");
                    if (hamburger) {
                        hamburger.focus();
                    }
                }
            }
        };

        if (targets.length > 0) {
            const target = targets[0];
            if (target) {
                const observer = new MutationObserver(function (mutations, observer) {
                    mutations.forEach(expansionCallback);
                });

                observer.observe(target, {
                    attributes: true,
                    attributeList: ['aria-expanded'],
                    childList: false,
                    subtree: false
                });

                // on escape key, close sidebar menu for keyboard nav users
                document.addEventListener('keyup', event => {
                    if (event.key === "Escape" && document.body.classList.contains("menu-open")) {
                        target.click();
                    }
                });
            }
        }
    }

    function NavItem() {
        const observer = new MutationObserver(function (mutations, observer) {
            mutations.forEach(function (mutation) {
                var flyout = header.querySelector(".navbar-not-collapsed .show");

                if (flyout) {
                    document.body.classList.add("flyout-open");
                } else {
                    document.body.classList.remove("flyout-open");
                }
            });
        });

        header.querySelectorAll('.navbar-not-collapsed .dropdown-toggle').forEach(function (flyout) {
            observer.observe(flyout, {
                attributes: true,
                attributeList: ['aria-expanded'],
                childList: false,
                subtree: false
            });
        });
    }

    function Searchbox() {
        let searchToggler = header.querySelector('.js-search');

        if (searchToggler) {
            searchToggler.querySelector('.hi-button-search').addEventListener('click', function (ev) {
                searchToggler.classList.toggle('open');

                if (searchToggler.classList.contains('open')) {
                    document.body.classList.add('search-open');
                    setTimeout(function () {
                        document.querySelector("#headerSearch").focus();
                    }, 350);
                } else {
                    document.body.classList.remove('search-open');
                }
            });

            // on escape key, close search menu for keyboard nav users
            document.addEventListener('keyup', event => {
                if (event.key === "Escape" && document.body.classList.contains("search-open")) {
                    searchToggler.querySelector('.hi-button-search').click();
                    searchToggler.querySelector('.hi-button-search').focus();
                }
            });

            searchToggler.querySelector('.js-do-search').addEventListener('click', function (ev) {
                var destination = searchToggler.getAttribute("data-search");
                var input = "";

                if (searchToggler.querySelector("input").value) {
                    input = searchToggler.querySelector("input").value.Cleanse();
                };

                if (destination && input) {
                    window.location = destination + "?q=" + input;
                }
            });

            searchToggler.querySelector("input").addEventListener('keyup',
                event => {
                    if (event.keyCode === 13) {
                        var destination = searchToggler.getAttribute("data-search");
                        var input = event.target.value;

                        if (destination && input) {
                            window.location = destination + "?q=" + input;
                        }
                    }
                });
        }
    }

    function ScrollTransform() {
        if (window.pageYOffset > header.offsetTop) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
    }

    function ActiveStates() {
        header.querySelectorAll("a.active").forEach(function (anchor) {
            anchor.closest(".nav-item").classList.add("active-section");
        });
    }
}

export default hiHeader();